<sm-title-bar
  pageTitle="{{ 'followers_public_media.title' | translate }}"
  [backWithParams]="true"
>

</sm-title-bar>

<div class="row" style="padding-bottom: 40px;">
    <div class="col-sm-3 col-md-3 col-lg-3" *ngFor="let item of publicMediaData" style="margin-bottom: 20px;">
        <div style="height: 400px;">
            <a [href]="item.imgUrl" target="_blank">
                <img [src]="item.thumbImgUrl" alt="">
            </a>
        </div>
    </div>
</div>